import React from "react";
import { useHistory } from "react-router-dom";
import { Container, Wrapper, Title, NavbarLink, Icon, IconWrapper } from "./style";
export default function Main() {
  const history = useHistory();
  const myWork = () => {
    history.push("/mywork");
  };
  return (
    <Container>
      <Wrapper main>
        <Wrapper content>
          <Title>Hello, I'm</Title>
          <br /> <Title user>Sardorbek Kholdarboev</Title>
          <Wrapper animated>
            <Title title>Web Developer</Title>
            <Title title>Blogger</Title>
            <Title title>Blogger</Title>
          </Wrapper>
          <NavbarLink onClick={myWork} btn>
            See my work
          </NavbarLink>
          <IconWrapper main>
            <IconWrapper href="https://github.com/kholdarboev" target="blank">
              <Icon.Github />
            </IconWrapper>
            <IconWrapper href="https://www.linkedin.com/in/kholdarboev/" target="blank">
              <Icon.Linkedin />
            </IconWrapper>
            <IconWrapper href="https://www.instagram.com/andijan_07/" target="blank">
              <Icon.Instagram />
            </IconWrapper>
          </IconWrapper>
        </Wrapper>
      </Wrapper>
    </Container>
  );
}
